module.exports = __webpack_public_path__ + "static/media/pringles.ca66d6a3.jpg";